/**
 * Attaches a callback to a delegated event listener for attaching events to asynchronous renders.
 * Returns a reference to the handler function for usage in window.removeEventListener.
 *
 * let eventHandler = delegateEventListener('click', 'a', (triggeringElement: HTMLElement, originalEvent: Event) => {});
 * window.removeEventListener('click', eventHandler);
 */
export function delegateEventListener(
  eventName: string,
  selector: string,
  callback: (element: HTMLElement, event: Event) => void
): (e: Event) => void | void {
  const handlerFn = (e) => {
    const eventTargetMatch = (e.target as HTMLElement).closest(selector);
    if (eventTargetMatch) {
      callback(eventTargetMatch as HTMLElement, e);
    }
  };
  window.addEventListener(eventName, handlerFn);
  return handlerFn;
}
